import { useCallback, useContext, useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { SchoolContext } from '../../../Providers/SchoolProvider'
import { isArray, isObject } from 'lodash'
import { isSchoolUser } from '../../../utils/roles'
import { selectUser } from '../../../reducers/UserReducer'
import { useSelector } from 'react-redux'

const SchoolSectionsSelector = ({ filter, multiple = 'default', schoolSections = null, style = {}, values, onChange, disabled = false }) => {
  const sc = useContext(SchoolContext)
  const user = useSelector(selectUser)

  const localSections = useMemo(() => {
    let localSections = []

    if (isArray(schoolSections)) {
      localSections = schoolSections
    } else if (isObject(sc) && isArray(sc?.schoolSections)) {
      localSections = sc?.schoolSections
    }

    return localSections
  }, [sc?.schoolSections, schoolSections])

  const isSchool = isSchoolUser(user)

  const mapToOptions = useCallback(section => {
    const { abbreviation, name, schoolYearName } = isSchool
      ? {
        abbreviation: section.sectionToYear.sectionAbbreviation,
        name: section.sectionToYear.sectionName,
        schoolYearName: section.sectionToYear.schoolYearName
      }
      : section

    return {
      label: `${abbreviation} (${schoolYearName})`,
      value: section.id,
      tooltip: `${name} (${schoolYearName})`,
      entity: section
    }
  }, [isSchool])

  const sectionOptions = useMemo(() => typeof filter === 'function'
    ? localSections.filter(filter).map(mapToOptions)
    : localSections.map(mapToOptions)
  , [localSections, filter, mapToOptions])

  return (
    <EntitiesSelector
      multiple={multiple}
      values={values}
      onChange={onChange}
      entityOptions={sectionOptions}
      style={{ ...style }}
      disabled={disabled}
    />
  )
}

export default SchoolSectionsSelector
